import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { FileCopy } from '@material-ui/icons';
import { ActionItem } from 'common/components';
import commonMessages from 'common/messages/messages';
import messages from 'modules/booking/messages';
import ActionItemWarningIcon from 'common/components/ActionsMenu/ActionItemWarningIcon';
import BookingActionItemContainer from 'components/Booking/BookingActionItemContainer';

interface IBookingActionItemDuplicate {
  onClick: () => void;
  isEventCanceled: boolean;
}

const BookingActionItemDuplicate: FC<IBookingActionItemDuplicate> = ({
  onClick,
  isEventCanceled,
}) => {
  const intl = useIntl();
  let disableReason: JSX.Element | null = null;

  if (isEventCanceled) {
    disableReason = (
      <ActionItemWarningIcon tooltipMessage={intl.formatMessage(messages.eventIsCanceled)} />
    );
  }

  const disabled = !!disableReason;

  return (
    <ActionItem
      key="duplicateEventAction"
      disabled={disabled}
      onClick={!disabled ? onClick : undefined}
      icon={<FileCopy fontSize="small" />}
    >
      <BookingActionItemContainer message={intl.formatMessage(commonMessages.duplicateButton)}>
        {disableReason}
      </BookingActionItemContainer>
    </ActionItem>
  );
};

export default BookingActionItemDuplicate;
